import request from "@/utils/request.js";
import { DownloadFile } from "@/utils/utils.js";
import { LANGUAGE_PACK } from "./config.js";
import _ from "lodash";
import { version, MoonRingTaskI18n } from "@/locales";

/**
 * 获取所有所有语言包的资源路径
 * - 用于判断版本号
 * - 用于获取子模块的资源和版本号
 */
export const getAllLanguage = async (module) => {
  let res;
  try {
    res = await DownloadFile(LANGUAGE_PACK.get_all_language);
    console.log("getAllLanguage get_all_language", res);
  } catch (error) {
    res = {};
  }
  const { h5_center } = res;
  console.log("getAllLanguage get_all_language h5_center", h5_center);

  // 版本判断
  if (version == res?.version) {
    return true;
  } else {
    // 不符合返回最新对应模块数据
    if (module == "getMoonRingTask" && h5_center) {
      // 周日任务
      return h5_center;
    } else {
      // 都不符合的情况下 - 沿用本地
      return true;
    }
  }
};

/**
 * 任务-语言包
 */
export const getMoonRingTask = async () => {
  const versionConfig = await getAllLanguage("getMoonRingTask");
  console.log("versionConfig: ", versionConfig);
  
  if (versionConfig == true) {
    return MoonRingTaskI18n;
  } else {
    return DownloadFile(versionConfig?.resource_path);
  }
};
